import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {  
  component: Subject<any>;
  
  constructor() {
    if(!this.component) {
      this.component = new Subject<any>();
    }
  }  

  add(tt: any) {
    this.component.next(tt);
  }

  remove() {
    this.component.next(null);
  }

  getComponents() {
    return this.component.asObservable();
  }
}
